<div class="flex flex-col items-center w-full">

    <!-- Zone caméra / photo -->
    <div class="relative w-[315px] h-[389px] bg-black rounded-md overflow-hidden shadow-lg">

        <!-- Vidéo en direct -->
        @if (!capturedImage()) {
        <video #videoElement autoplay playsinline muted
            class="w-full h-full object-cover scale-x-[-1]">
        </video>

        <!-- Filigrane silhouette -->
        @if (cameraReady() && showSilhouette) {
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="absolute inset-0 w-full h-full pointer-events-none">
            <path d="M0 0 C103.95 0 207.9 0 315 0 C315 128.37 315 256.74 315 389 C305.63944289 389 300.76317664 388.81086491 292.765625 385.34375 C291.84392517 384.96319458 290.92222534 384.58263916 289.97259521 384.19055176 C287.05642806 382.97993698 284.15375788 381.7400355 281.25 380.5 C279.32106387 379.69870968 277.39137982 378.89921735 275.4609375 378.1015625 C266.8533974 374.51822936 258.32124544 370.80295487 249.9609375 366.671875 C249.33052551 366.36262085 248.70011353 366.0533667 248.05059814 365.73474121 C236.65086425 359.95860555 230.18751011 351.70815261 226.23046875 339.65625 C225.67149783 337.43645183 225.29719149 335.26946226 225 333 C224.89042969 332.18015625 224.78085938 331.3603125 224.66796875 330.515625 C224.33186242 327.34278127 224.15433188 324.18728885 224 321 C223.95004883 320.19852539 223.90009766 319.39705078 223.84863281 318.57128906 C222.74454788 299.43616108 222.74454788 299.43616108 229.0625 292.2265625 C239.3803103 280.36940147 242.47954472 261.96685178 246 247 C246.886875 247.061875 247.77375 247.12375 248.6875 247.1875 C252.45882415 246.97402882 254.04713923 246.31332409 257 244 C268.05807331 228.59477256 272.82631239 203.59696594 271 185 C269.41786054 180.68698943 269.41786054 180.68698943 266 178 C264.62657169 177.9310528 263.24997898 177.91532292 261.875 177.9375 C259.956875 177.9684375 259.956875 177.9684375 258 178 C257.99120064 177.15460411 257.99120064 177.15460411 257.98222351 176.29212952 C257.91745094 170.33645771 257.83283647 164.3812853 257.73754883 158.42602539 C257.70463684 156.21417903 257.6765044 154.00225546 257.65356445 151.7902832 C257.34361265 122.67459782 252.77518625 94.56036513 232.75 72.1015625 C231 70 231 70 230 67 C228.68224195 66.30305241 227.34529788 65.64218052 226 65 C224.35150231 63.65326121 222.72910233 62.27432331 221.125 60.875 C197.10175653 41.00471085 168.14221893 37.51442203 138 39 C118.34091789 41.07713765 98.65580658 49.81429747 84 63 C83.52175781 63.42909668 83.04351562 63.85819336 82.55078125 64.30029297 C74.46226073 71.66365371 68.4406279 79.53218568 63 89 C62.50886719 89.84046875 62.01773438 90.6809375 61.51171875 91.546875 C47.22681076 117.90540491 49.59655683 149.06381482 50 178 C47.99397786 177.96541341 45.98795573 177.93082682 43.98193359 177.89624023 C41.86889145 177.88759402 41.86889145 177.88759402 39.625 179.0625 C34.78243224 184.83633079 35.8538155 192.61136429 36.46484375 199.6171875 C37.95089429 213.08470811 42.13602913 237.02500811 53 246 C55.26393971 246.78356902 55.26393971 246.78356902 57.6875 247.1875 C58.49574219 247.34605469 59.30398437 247.50460938 60.13671875 247.66796875 C60.75160156 247.77753906 61.36648437 247.88710937 62 248 C62.43699219 249.8871875 62.43699219 249.8871875 62.8828125 251.8125 C66.65967256 267.74099678 70.84248982 284.85823058 81.3125 297.875 C87.24430476 305.34468007 83.70654902 321.11973359 83 330 C82.09200215 337.75810992 80.38408343 345.43820192 76 352 C75.56429687 352.65226562 75.12859375 353.30453125 74.6796875 353.9765625 C62.14602373 370.28922037 34.49305643 377.25420118 16.25 384.6875 C15.19707764 385.12175293 14.14415527 385.55600586 13.05932617 386.00341797 C12.07552979 386.39803223 11.0917334 386.79264648 10.078125 387.19921875 C8.78503418 387.72261841 8.78503418 387.72261841 7.46582031 388.2565918 C5 389 5 389 0 389 C0 260.63 0 132.26 0 0 Z "
                fill="rgba(255,255,255,0.55)" transform="translate(0,0)" />
        </svg>

        }

        <!-- Décompte -->
        @if (countdown() !== null) {
        <div class="absolute inset-0 flex items-center justify-center bg-black/30">
            <span class="text-white text-8xl font-bold animate-pulse drop-shadow-lg">
                {{ countdown() }}
            </span>
        </div>
        }

        <!-- Erreur caméra -->
        @if (cameraError()) {
        <div class="absolute inset-0 flex flex-col items-center justify-center bg-gray-800 text-white p-4 text-center">
            <i class="fas fa-video-slash text-4xl mb-3 text-red-400"></i>
            <p class="text-sm">{{ 'vues.ipad.checkin.photo.camera-error' | translate }}</p>
        </div>
        }
        }

        <!-- Photo capturée -->
        @if (capturedImage()) {
        <img [src]="capturedImage()" alt="Captured photo" class="w-full h-full object-cover">
        }

    </div>

    <!-- Canvas caché pour la capture -->
    <canvas #canvasElement class="hidden"></canvas>

    <!-- Bouton capture / reprendre -->
    <div class="mt-4 flex flex-col items-center gap-3">

        @if (!capturedImage()) {
        <!-- Bouton prendre photo -->
        <button (click)="startCountdown()"
            [disabled]="!cameraReady() || countdown() !== null"
            class="bg-red-600 hover:bg-red-700 disabled:bg-gray-400 text-white px-6 py-3 rounded-sm shadow-lg flex items-center gap-2 transition">
            <i class="fas fa-camera text-lg"></i>
            @if (countdown() !== null) {
            <span class="font-bold">{{ countdown() }}...</span>
            } @else {
            <span class="font-semibold">{{ 'vues.ipad.checkin.photo.take' | translate }}</span>
            }
        </button>
        <p class="text-sm text-blue-600 text-center">{{ instructionsKey | translate }}</p>
        }

        @if (capturedImage()) {
        <!-- Bouton reprendre -->
        <button (click)="retakePhoto()"
            class="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-sm shadow flex items-center gap-2 transition">
            <i class="fas fa-redo text-lg"></i>
            <span class="font-semibold">{{ 'vues.ipad.checkin.photo.retake' | translate }}</span>
        </button>
        }

    </div>

</div>